module.exports = __webpack_public_path__ + "img/0287-user-blue.890e3f5f.svg";